export default function Announcement() {
  return (
    <div className="bg-teal-500 font-semibold p-2 flex justify-center text-2xs sm:text-xs text-center md:text-sm xl:text-lg">
      We are opening 5 new branches nationwide. Sign up for our newsletter to
      receive updates and more.
    </div>
  )
}
